import React from 'react';
import  {IndexLink,Link} from 'react-router';


export default class Splash_About extends React.Component{
	render() {
    return (
    	<div>
    		<div className="page_wrapper_full">
				<p className="page_content_image">
				<img src="static/img/homeimg/about_top.jpeg" alt="about" />
				</p>
				<div className="page_overlay_wrapper" >
					<div className="page_overlay_content">
						<h2>
							Stay Connected
						</h2>
						<h3>
							Wherever you go, whatever you do, stay close to the people that matter.
						</h3>
					</div>
				</div>
			</div>
			<div className="page_wrapper tcenter about_bottom">
				<h2>Way to connect</h2>
				<h3>You share the same interests. Experiences. Sense of humor. Lots of things brought you<br />together in the first place. Check out some of the ways we help you stay connected.</h3>
				<div className="item"><a href="#"><img src="static/img/homeimg/about_NewFeed.png" alt="" width="120px" height="120px" /></a>
					<h4>New Feeds</h4>
					<h5>Stay up to date with your university.</h5>
				</div>
				<div className="item"><a href="#"><img src="static/img/homeimg/about_Messenger.png" alt="" width="120px" height="120px" /></a>
					<h4>Messengers</h4>
					<h5>Stay connected texting that's<br />private and free.</h5>
				</div>
				<div className="item"><a href="#"><img src="static/img/homeimg/about_Profile.png" alt="" width="120px" height="120px" /></a>
					<h4>Profile</h4>
					<h5>Build a perfect profile for<br />your educational network.</h5>
				</div>
				<div className="item"><a href="#"><img src="static/img/homeimg/about_Share.png" alt="" width="120px" height="120px" /></a>
					<h4>Share</h4>
					<h5>Get access to notes and files.</h5>
				</div>
				<div className="item"><a href="#"><img src="static/img/homeimg/about_Event.png" alt="" width="120px" height="120px" /></a>
					<h4>Events</h4>
					<h5>Alway stay up to date<br />with your campus.</h5>
				</div>
				<div className="item"><a href="#"><img src="static/img/homeimg/about_Search.png" alt="" width="120px" height="120px" /></a>
					<h4>Search</h4>
					<h5>Find peers or alumni from<br />any university.</h5>
				</div>
			</div>
		</div>
      
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/commons/splash_about.js
 **/